import { authInstance } from "./axios";
let url = process.env.REACT_APP_API_URL;

export const papService = {
  getMembershipById: async (membershipId) => {
    const response = await authInstance
      .get(`${url}/paps/${membershipId}`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
};
